import { combineTokens } from '@utils/css';

const tokens = combineTokens("--readonly-input", {
  x: 0,
  y: 0,
  scale: 1
});
const text = "_35st1jd8phb";

export { text, tokens };
import "./input.readonly.style.linaria.module.css";
//# sourceMappingURL=input.readonly.style.js.map
